<template>
  <div :class="sidebarClasses">
    <div class="sidebar-wrapper">
      <div class="logo">
        <span class="simple-text">
          <img class="logo-img" :src="require('../../assets/appicons/placeholder.jpg')" alt="Roscon">
          Roscon
        </span>
      </div>
      <slot>
      </slot>
      <ul :class="navClasses" v-if="$user.loggedIn">
        <li class="nav-item" v-for="(link,index) in sidebarLinks" :key="link.name + index" @click="toggleSidebar">
          <a class="nav-link" v-if="link.uuid === 'contactLink'" :href="link.path" target="_blank">
            <p>
              <img
                class="nav-item-img" 
                :src="link.img ? 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + link.img : require('../../assets/appicons/placeholder.jpg')" 
                alt="Roscon Admin" />
              {{link.name}}
            </p>
          </a>
          <router-link class="nav-link" :to="link.path" :ref="link.name" v-else>
            <p>
              <img
                class="nav-item-img" 
                :src="link.img ? 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + link.img : require('../../assets/appicons/placeholder.jpg')" 
                alt="Roscon Admin" />
              {{link.name}}
            </p>
          </router-link>
        </li>
      </ul>
      <moving-arrow v-if="$user.loggedIn" :move-y="arrowMovePx"></moving-arrow>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {
    ACTIVE_LINK,
    LOAD_SIDEBAR
  } from '@/vuex/types'
  import MovingArrow from './MovingArrow.vue'
  export default {
    name: 'SideBar',
    props: {
      type: {
        type: String,
        default: 'sidebar'
      },
      sidebarLinks: {
        type: Array,
        default: []
      },
      showSidebar: {
        type: Boolean,
        default: false
      }
    },
    components: {
      MovingArrow
    },
    computed: {
      ...mapGetters([
        '$sidebar'
      ]),
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav flex-column'
        } else {
          return 'nav navbar-nav'
        }
      },
      arrowMovePx () {
        return this.linkHeight * this.activeLinkIndex
      }
    },
    data () {
      return {
        linkHeight: 44,
        activeLinkIndex: 0,
        windowWidth: 0,
        hasAutoHeight: false
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$store.commit('displaySidebar', false)
        }
      },
      findActiveLink () {
        this.sidebarLinks.find((element, index) => {
          let found = this.$route.path.includes(element.path)
          if (found) {
            this.activeLinkIndex = index
            this.$store.commit(ACTIVE_LINK, element)
          }
          return found
        })
      }
    },
    async mounted () {
      await this.$store.dispatch(LOAD_SIDEBAR)
      this.findActiveLink()
    },
    watch: {
      $route: async function (newRoute, oldRoute) {
        await this.$store.dispatch(LOAD_SIDEBAR)
        this.findActiveLink()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/SideBar.vue